export default {
  methods: {
    getScrollTop() {
      if (self.pageYOffset) {
        return self.pageYOffset;
      }
      if (document.documentElement && document.documentElement.scrollTop) {
        return document.documentElement.scrollTop;
      }
      if (document.body.scrollTop) {
        return document.body.scrollTop;
      }
      return 0;
    },
    getElementTop(element) {
      let top = 0;
      do {
        top += element.offsetTop  || 0;
        element = element.offsetParent;
      } while(element);
      return top;
    },
    getElementLeft(element) {
      let left = 0;
      do {
        left += element.offsetLeft  || 0;
        element = element.offsetParent;
      } while(element);
      return left;
    },
    scrollTimer(offsetY, interval) {
      setTimeout(function() {
        window.scrollTo(0, offsetY);
      }, interval);
    },
    scrollToElement(elementRef, offsetY) {
      let targetEl = this.$refs[elementRef];
      if (!targetEl) {
        return ;
      }

      let startY = this.getScrollTop();
      let stopY = this.getElementTop(targetEl) - offsetY;

      let distance = stopY > startY ? stopY - startY : startY - stopY;
      if (distance < 100) {
        window.scrollTo(0, stopY); return;
      }
      let speed = Math.round(window.innerHeight * 10 / distance);
      if (speed >= 20) {
        speed = 20;
      }
      let step = Math.round(distance / 25);
      let leapY = stopY > startY ? startY + step : startY - step;
      let timer = 0;
      if (stopY > startY) {
        for ( let i = startY; i < stopY; i += step ) {
          this.scrollTimer(leapY, timer * speed);
          leapY += step;
          if (leapY > stopY) {
            leapY = stopY;
          }
          timer++;
        }
        return;
      }
      for ( let i = startY; i > stopY; i -= step ) {
        this.scrollTimer(leapY, timer * speed);
        leapY -= step;
        if (leapY < stopY) {
          leapY = stopY;
        }
        timer++;
      }
    },
    hideMainNavBar(appRef, navClass) {
      let appElement = this.$refs[appRef];
      let navElement = document.body.querySelector(navClass);

      if(!appElement || !navElement) {
        return ;
      }

      let app_top = this.getElementTop(appElement) - navElement.clientHeight;
      let cur_top = this.getScrollTop();

      if(cur_top >= app_top && cur_top <= app_top + appElement.clientHeight) {
        navElement.style.position = 'relative';
      } else {
        navElement.style.position = 'fixed';
      }

      if(cur_top == 0) {
        navElement.style.position = 'relative';
      }
    },
    hideTableNavBar(appRef, navRef) {
      let appElement = this.$refs[appRef];
      let navElement = this.$refs[navRef];

      if(!appElement || !navElement) {
        return ;
      }

      if (Array.isArray(navElement)) {
        if (!navElement.length) {
          return;
        }
        navElement = navElement[0];
      }

      let app_top = this.getElementTop(appElement);
      let cur_top = this.getScrollTop();

      if(cur_top >= app_top / 2 && cur_top <= app_top + appElement.clientHeight * 3 / 4) {
        navElement.style.display = 'block';
      } else {
        navElement.style.display = 'none';
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/scrollHandler.js